import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import { authenticationRequired } from "@/authentication";
import {
  chileanRoutes,
  peruvianRoutes,
  adminRoutes,
  development
} from "@/dynamic.routes";
import Home from "@/views/Home.vue";
import HomeNew from "@/views/HomeNew.vue";
import DashboardRoutes from "@/router.dashboard";
import DashboardRoutesFactoring from "@/router.dashboard.factoring";
import { EventBus } from "@/main";
import { isUserLogin } from "./utils";
import { SelectedCountry, State } from "./configuration";

Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "hometest2",
      component: HomeNew
    },
    {
      path: "/login",
      name: "newlogin",
      component: () => import("@/views/NewLogin.vue")
    },
    {
      path: "/simulacion-cuotas",
      name: "simulacion-cuotas",
      component: () => import("@/views/SimulacionCuotas.vue")
    },
    {
      path: "/referidos/:id",
      name: "QuestionsReferidos",
      component: () =>
        import(/* webpackChunkName: "dashboardactividad" */ "@/views/QuestionsReferidos.vue"),
        props: true
    },
    {
      path: "/actividad/administracion",
      name: "AdministracionDashboard",
      component: () =>
        import(/* webpackChunkName: "dashboardactividad" */ "@/views/actividad/dashboard.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/actividad/admin-user",
      name: "AdministracionDashboardUser",
      component: () =>
        import(/* webpackChunkName: "dashboardactividad" */ "@/views/actividad/dashboarduser.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/actividad/sabermas",
      name: "sabermas",
      component: () =>
        import(/* webpackChunkName: "sabermas" */ "@/views/actividad/Sabermas.vue"),
      beforeEnter: authenticationRequired,
    },
    {
      path: "/actividad/administrarfinanzas",
      name: "AdministracionOrganiza",
      component: () =>
        import(/* webpackChunkName: "AdministracionOrganiza" */ "@/views/actividad/AdministracionActividad1.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/actividad/administrarcostos",
      name: "AdministracionCostos",
      component: () =>
        import(/* webpackChunkName: "dashboard-controla-tus-costos" */ "@/views/actividad/AdministracionActividad2.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/actividad/administrarfuturo",
      name: "AdministracionFuturo",
      component: () =>
        import(/* webpackChunkName: "dashboard-planifica-tu-futuro" */ "@/views/actividad/AdministracionActividad3.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/actividad/administrardeuda",
      name: "AdministracionDeuda",
      component: () =>
        import(/* webpackChunkName: "dashboard-gestiona-tu-deuda" */ "@/views/actividad/AdministracionActividad4.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/actividad/organiza/",
      name: "actividad-organiza-tus-finanzas",
      component: () =>
        import(/* webpackChunkName: "actividad-organiza-tus-finanzas" */ "@/views/actividad/OrganizaTusFinanzas.vue"),
      beforeEnter: authenticationRequired,
      props: true
    },
    {
      path: "/actividad/costos",
      name: "controla-tus-gastos",
      component: () =>
        import(/* webpackChunkName: "controla-tus-gastos" */ "@/views/actividad/ControlaTusCostos.vue"),
      beforeEnter: authenticationRequired,
      props: true
    },
    {
      path: "/actividad/metasacortoplazo",
      name: "metas-a-corto-plazo",
      component: () =>
        import(/* webpackChunkName: "metas-a-corto-plazo" */ "@/views/actividad/MetasaCortoPlazo.vue"),
      beforeEnter: authenticationRequired,
      props: true
    },
    {
      path: "/actividad/gestionatudeuda",
      name: "gestiona-tu-deuda",
      component: () =>
        import(/* webpackChunkName: "gestiona-tu-deuda" */ "@/views/actividad/GestionaTuDeuda.vue"),
      beforeEnter: authenticationRequired,
      props: true
    },
    {
      path: "/scoring",
      name: "pruebas-scoring",
      component: () => import("@/views/scoring/ScoringV2.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/angloamerican",
      name: "pruebas-angloamerican",
      component: () => import("@/views/AngloAmerican.vue"),
      /* component: () => import("@/views/angloAmerican/AngloAmericanV2.vue"), */
      beforeEnter: authenticationRequired
    },
    /* {
      path: "/angloamericanv2",
      name: "pruebas-angloamerican2",
      component: () => import("@/views/angloAmerican/AngloAmericanV2.vue"),
      beforeEnter: authenticationRequired
    }, */
    {
      path: "/evaluacion",
      name: "scoring",
      component: () => import("@/views/scoring/ScoringV2.vue"),
      //component: () => import("@/views/Scoring.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/simulacion-facturas",
      name: "simulacion-facturas",
      component: () => import("@/views/SimulacionFacturas.vue")
    },
    {
      path: "/admin/asociar",
      name: "asociate",
      component: () =>
        import(/* webpackChunkName: "asociate"*/ "@/views/admin/Asociate.vue"),
      beforeEnter: adminRoutes
    },
    {
      path: "/pruebas",
      name: "test",
      component: () => import(/* webpackChunkName: "test"*/ "@/views/Test.vue")
    },
    {
      path: "/solicitante",
      name: "solicitante",
      component: () =>
        import(/* webpackChunkName: "applicant" */ "@/views/Applicant.vue")
    },
    {
      path: "/contacto",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "contact" */ "@/views/Contact.vue")
    },
    {
      path: "/landing",
      name: "landing",
      component: () =>
        import(/* webpackChunkName: "landing" */ "@/views/Landing.vue")
    },
    {
      path: "/santander",
      name: "landing-santander",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingSantander.vue"
        ),
      beforeEnter: chileanRoutes
    },
    {
      path: "/cotizafactoring",
      name: "landing-cotizafactoring",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingCotizaFactoring.vue"
        ),
      beforeEnter: chileanRoutes
    },
    {
      path: "/cotizafactoring2",
      name: "landing-cotizafactoring2",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingCotizaFactoring2.vue"
        ),
      beforeEnter: chileanRoutes
    },
    
    {
      path: "/fondoemprendedoressolidarios.cl",
      name: "landing-angloameriican",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingAngloAmerican.vue"
        ),
     // beforeEnter: chileanRoutes
    },
    {
      path: "/banigualdad",
      name: "landing-banigualdad",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingBanigualdad.vue"
        ),
      beforeEnter: chileanRoutes
    },
    {
      path: "/bcp",
      name: "landing-bcp",
      component: () =>
        import(/* webpackChunkName: "landing" */ "@/views/LandingBCP.vue"),
      beforeEnter: peruvianRoutes
    },
    /* {
      path: "/quienes-somos",
      name: "about",
      component: () =>
        import("@/views/About.vue")
    }, */
    {
      path: "/quienes-somos",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/aboutUs/AboutUs.vue")
    },
    // Como funciona invertir
    {
      path: "/como-funciona-invertir",
      name: "comofuncionainvertir",
      component: () =>
        import("@/views/HowItWorksNew.vue")
    },
    {
      path: "/como-funciona",
      redirect: "como-funciona-invertir"
    },
    {
      path: "/solicitud-credito",
      name: "credit",
      component: () =>
        import(/* webpackChunkName: "credit" */ "@/views/RequestCredit.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/solicitar-credito",
      name: "request-credit",
      component: () =>
        import(/* webpackChunkName: "request-credit" */ "@/views/Credit.vue")
    },
    {
      path: "/garantia-riesgos",
      name: "warrantyrisk",
      component: () =>
        import(
          /* webpackChunkName: "warranty-and-risks" */ "@/views/Warranty.vue"
        )
    },
    {
      path: "/preguntas-frecuentes",
      name: "faq",
      component: () =>
        import(
          /* webpackChunkName: "frequently-asked-questions" */ "@/views/Faq.vue"
        )
    },
    {
      path: "/politica-privacidad",
      name: "politica-privacidad",
      component: () =>
        import(
          /* webpackChunkName: "frequently-asked-questions" */ "@/views/Politicas-privacidad.vue"
        )
    },
    {
      path: "/protocolo-cobranza",
      name: "protocolo-cobranza",
      component: () =>
        import(
          /* webpackChunkName: "frequently-asked-questions" */ "@/views/Protocolo-cobranza.vue"
        )
    },
    {
      path: "/ingresar",
      name: "login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/Login.vue")
    },
    {
      path: "/registrar",
      name: "register",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/Register.vue"),
      props: true
    },
    {
      path: "/crear-empresa",
      name: "create-business",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/factoring/NewCreateBusiness.vue"),
      beforeEnter: authenticationRequired
    },
    /* Crear Negocio, pagina que se muestra una vez se registra un usuario Anglo */
    {
      path: "/crear-negocio",
      name: "create-negocio",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/angloAmerican/CreaNegocio.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/gracias",
      name: "thankyou",
      component: () =>
        import(/* webpackChunkName: "thankyou" */ "@/views/ThankYou.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/registro",
      name: "register-requests",
      component: () =>
        import(
          /* webpackChunkName: "register-request" */ "@/views/RegisterRequest.vue"
        )
    },
    {
      path: "/recuperar",
      name: "recuperar",
      component: () =>
        import(/* webpackChunkName: "recover-password" */ "@/views/Recover.vue")
    },
    {
      path: "/recuperar/:token",
      name: "recuperar contraseña",
      component: () =>
        import(
          /* webpackChunkName: "new-password" */ "@/views/NewPassword.vue"
        ),
      props: true
    },
    {
      path: "/prensa",
      name: "press",
      component: () =>
        import(/* webpackChunkName: "press" */ "@/views/Press.vue")
    },
    {
      path: "/blog/:url",
      name: "article",
      component: () =>
        import(/* webpackChunkName: "blog" */ "@/views/BlogPost.vue"),
      props: true
    },
    {
      path: "/blog",
      name: "blog",
      component: () => import(/* webpackChunkName: "blog" */ "@/views/Blog.vue")
    },
    {
      path: "/lo-sentimos",
      name: "lo-sentimos",
      component: () =>
        import(/* webpackChunkName: "sorry" */ "@/views/Decline.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/agendar",
      name: "schedule",
      component: () =>
        import(/* webpackChunkName: "schedule" */ "@/views/Schedule.vue"),
      beforeEnter: chileanRoutes
    },
    {
      path: "/agendar-llamada/:requestId",
      name: "schedule-call",
      component: () =>
        import(/* webpackChunkName: "schedule" */ "@/views/ScheduleCall.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/agenda-llamada-exitosa",
      name: "schedule-call-success",
      component: () =>
        import(/* webpackChunkName: "" */ "@/views/ScheduleCallSuccess.vue")
    },
    {
      path: "/chilecompra",
      name: "chilecompra-form",
      component: () =>
        import(
          /* webpackChunkName: "chilecompra" */ "@/views/ChileCompraForm.vue"
        ),
      beforeEnter: chileanRoutes
    },
    {
      path: "/chilecompra-exitosa",
      name: "chilecompra-success",
      component: () =>
        import(
          /* webpackChunkName: "chilecompra" */ "@/views/ChileCompraSuccess.vue"
        ),
      beforeEnter: chileanRoutes
    },
    {
      path: "/agenda-exitosa",
      name: "schedule-thanks",
      component: () =>
        import(/* webpackChunkName: "schedule" */ "@/views/ScheduleThanks.vue"),
      beforeEnter: chileanRoutes
    },
    {
      path: "/invertir",
      name: "investment",
      component: () =>
        import(
          /* webpackChunkName: "investment-opportunities" */ "@/views/Investment.vue"
        ),
      beforeEnter: (to: any, from: any, next: any) => {
        if (SelectedCountry == "PYME") {
          next("/");
        } else {
          isUserLogin(
            () => {
              next();
            },
            () => {
              if (SelectedCountry == "PE") {
                store.commit("logout");
                next(`/ingresar?return=${to.path}`);
              } 
              else {
                next();
              }
            }
          );
        }
      }
    },
    {
      path: "/prontopago",
      name:"prontopago",
      redirect: (to)=>{
        window.location.href = 'https://prontopago.redcapital.cl/';
      }
    },
    {
      path: "/simulacion/proyecto-:projectId",
      name: "simulation",
      component: () =>
        import(/* webpackChunkName: "simulation" */ "@/views/Simulation.vue"),
      // beforeEnter: authenticationRequired,
      // Desactivar en chile
      props: true
    },
    {
      path: "/inversion-realizada",
      name: "investment-completed",
      component: () =>
        import(
          /* webpackChunkName: "investment-completed"*/ "@/views/InvestmentCompleted.vue"
        )
    },
    {
      path: "/ver-proyecto/:projectId",
      name: "view-project",
      component: () =>
        import(
          /* webpackChunkName: "view-project" */ "@/views/ViewProject.vue"
        ),
      beforeEnter: authenticationRequired,
      props: true
    },
    {
      path: "/pago-exitoso",
      name: "successful-payment",
      component: () =>
        import(
          /* webpackChunkName: "successful-payment" */ "@/views/SuccessfulPayment.vue"
        ),
      beforeEnter: authenticationRequired
    },
    {
      path: "/pago-erroneo",
      name: "failure-payment",
      component: () =>
        import(
          /* webpackChunkName: "failure-payment" */ "@/views/FailurePayment.vue"
        ),
      beforeEnter: authenticationRequired
    },
    {
      path: "/reserva-exitosa",
      name: "successful-reserving",
      component: () =>
        import(
          /* webpackChunkName: "successful-reserving" */ "@/views/SuccessfulReserving.vue"
        )
    },
    {
      path: "/informar-pago",
      name: "payment-info",
      component: () =>
        import(
          /* webpackChunkName: "payment-info" */ "@/views/ReportPayment.vue"
        ),
      beforeEnter: authenticationRequired
    },
    // Como funciona solicitar
    {
      path: "/solicitar",
      redirect: "/como-funciona-solicitar"
    },
    {
      path: "/como-funciona-solicitar",
      name: "comofuncionasolicitar", //old Action
      component: () =>
        import(/* webpackChunkName: "action" */ "@/views/HowItWorkSolicit.vue"),
      beforeEnter: chileanRoutes
    },
    {
      path: "/controla-tus-facturas",
      name: "homeprontopago", //old Action
      component: () =>
        import(/* webpackChunkName: "action" */ "@/views/prontoPago/HomeProntoPago.vue"),
      beforeEnter: chileanRoutes
    },
    {
      path: "/caso-de-estudio/:idCaso",
      name: "caso-estudio-1",
      component: () =>
        import("@/views/studyCase/StudyCase.vue"),
      beforeEnter: chileanRoutes
    },
    {
      path: "/financiamiento",
      name: "finance",
      component: () =>
        import(/* webpackChunkName: "financing" */ "@/views/Financing.vue"),
      beforeEnter: chileanRoutes
    },
    {
      path: "/conocerte",
      name: "meet-you",
      component: () =>
        import(/* webpackChunkName: "meet-you" */ "@/views/MeetYou.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/crear-empresa",
      name: "create-business",
      component: () =>
        import(
          /* webpackChunkName: "create-business" */ "@/views/CreateBusiness.vue"
        ),
      beforeEnter: authenticationRequired
    },
    {
      path: "/bienvenido",
      name: "welcome",
      component: () =>
        import(/* webpackChunkName: "filter" */ "@/views/Filter.vue"),
      beforeEnter: authenticationRequired
    },
    {
      path: "/bueno-saberlo",
      name: "good-to-know",
      component: () =>
        import(/* webpackChunkName: "good-to-know" */ "@/views/GoodToKnow.vue")
    },
    {
      path: "/gracias-por-invertir",
      name: "thanks-for-investing",
      component: () =>
        import(
          /* webpackChunkName: "thanks-for-investing" */ "@/views/ThanksForInvesting.vue"
        ),
      beforeEnter: authenticationRequired
    },

    {
      path: "/ingreso_clave_sii/:token",
      name: "ingreso-claveSii",
      component: () =>
        import(
          /* webpackChunkName: "view-project" */ "@/views/claveSii/ClaveSii.vue"
        ),
      //beforeEnter: authenticationRequired,
      props: true
    },
    {
      path: "/operacionempresas",
      name: "empresas-claveSii",
      component: () =>
        import(
          /* webpackChunkName: "view-project" */ "@/views/landingClaveSii.vue"
        )
    },

    ...DashboardRoutes.map(route => {
      route.path = `/panel/${route.path}`;
      route.name = `dashboard-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    ...DashboardRoutesFactoring.map(route => {
      route.path = `/panel-facto/${route.path}`;
      route.name = `dashboard-factoring-${route.name}`;
      route.beforeEnter = authenticationRequired;
      return route;
    }),
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/404.vue")
    },
    {
      path: "*",
      name: "not-found",
      redirect: "/404"
    },
    {
      path: "/mantenimiento",
      name: "mantenimiento",
      component: () => import("@/views/404-mantain.vue"),
      beforeEnter: development
    },
    {
      path: "/estamos-trabajando",
      name: "trabajando",
      component: () => import("@/views/404-working.vue"),
      beforeEnter: development
    },
    {
      path: "/nuestrosbeneficios",
      name: "landing-factoring-passuno",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingFactoringReg.vue"
        ),
      beforeEnter: chileanRoutes
    },
    {
      path: "/potenciatuPyme",
      name: "landing-factoring-passdos",
      component: () =>
        import(
          /* webpackChunkName: "landing" */ "@/views/LandingFactoringReg2.vue"
        ),
      beforeEnter: chileanRoutes
    },

    
    /*  {
      path: "/design-system-redcapital",
      name: "dsrc",
      component: () => import("@/views/designRc/designSystem.vue"),
      beforeEnter: chileanRoutes
    } */ 
  ]
});

router.afterEach((to, from) => {
  if (State == 2) {
    if (to.path != "/mantenimiento") {
      router.push({ path: "/mantenimiento" });
    }
  }
  if (State == 3) {
    if (to.path != "/estamos-trabajando") {
      router.push({ path: "/estamos-trabajando" });
    }
  }
});

router.afterEach((to, from) => {
  if(to.fullPath.indexOf('/panel') == 0){
    store.commit("setShowPanelInv",true)
  } else {
    store.commit("setShowPanelInv",false)
  }
  store.commit("setRoutes", { to: to.path, from: from.path });
});

const r = router;
// @ts-ignore

function getRoutesList(routes: any, pre: any) {
  return routes.reduce((array: any, route: any) => {
    const path = `${pre}${route.path}`;

    if (route.path !== "*") {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}/`));
    }
    return array;
  }, []);
}

export default router;
